import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { translationIT } from './it/it';
import { translationEN } from './en/en';

i18n.use( initReactI18next )
.use( Backend ) 
.use( LanguageDetector )
.init( {
  fallbackLng: "en",
  supportedLngs: ['it', 'en'],


  detection: {
    order: ['cookie', 'navigator', 'localStorage', 'path', 'subdomain'],
    caches: ['cookie']
  }, 

  interpolation: { escapeValue: false },

  resources: {
    it: { translation: translationIT },
    en: { translation: translationEN },
  },

} );

export default i18n;